module.exports = __webpack_public_path__ + "img/flowLogo.31d56340.png";